const groupSchema = [
    {
        label: "Field One",
        name: "field_one",
        rules: "required",
        type: "text",
        help: "Enter something here.",
        placeholder: "Something",
    },
    {
        label: "Field Two",
        name: "field_two",
        rules: "",
        type: "date",
        help: "This is a nested date.",
    },
    {
        label: "Email",
        name: "email",
        rules: "",
        type: "email",
        help: "Your best email address",
        placeholder: "you@company.com",
    },
    {
        label: "Last Field",
        name: "last_field",
        rules: "required",
        type: "text",
        help: "Almost done...",
    },
];

const schema = [
    {
        label: 'Field One',
        name: 'field_one',
        rules: 'required',
        type: 'text',
        help: 'Enter something here.',
        placeholder: 'Something',
        extraone: 'extra',
    },
    {
        label: 'Field Two',
        name: 'field_two',
        rules: '',
        type: 'date',
        help: 'This is a date field.',
        extratwo: 'extra',
    },
    {
        label: 'Email',
        name: 'email',
        rules: '',
        type: 'email',
        help: 'Your best email address',
        placeholder: 'you@company.com',
        extraemail: 'extra',
    },
    {
        label: 'Last Field',
        name: 'last_field',
        rules: 'required',
        type: 'text',
        help: 'Almost done... above',
        helpAbove: true,
        extralast: 'extra',
    },
    {
        label: 'Long One',
        name: 'long_field',
        rules: 'required',
        type: 'textarea',
        help: 'Write a book...',
        helpAbove: true,
    },
    {
        label: 'GROUP Field',
        name: 'group_field',
        //rules: 'required',
        type: 'group',
        children: [...groupSchema],
        help: 'This should be a group',
    },
]

export {
    schema
}